import { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import IconWrap from '@bridebook/ui/src/components/svg/icon-wrap';
import { IStylingProps } from '@bridebook/ui/src/themes/types';
import { TColor } from '@bridebook/ui/src/types';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconBellIllustration = ({ id, color, width = 161, style, ...restProps }: IProps) => {
  const viewBoxWidth = 161;
  const viewBoxHeight = 160;

  const icon = ({ width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      width={`${width}px`}
      height={`${height}px`}>
      <circle cx="80.5" cy="80" r="80" fill="#DBDCF9" />
      <ellipse
        cx="85.9532"
        cy="110.946"
        rx="8.24266"
        ry="6.68403"
        transform="rotate(172.383 85.9532 110.946)"
        fill="#D3912E"
      />
      <ellipse
        cx="74.9598"
        cy="52.0491"
        rx="5.46021"
        ry="6.68403"
        transform="rotate(170.289 74.9598 52.0491)"
        fill="#E5B227"
      />
      <path
        d="M110.118 99.6787L60.08 108.317C61.5174 105.829 63.6033 96.2831 60.4483 78.0086C57.2933 59.734 63.9311 52.763 74.8089 50.885C85.6866 49.007 94.2776 53.3488 97.4326 71.6234C100.588 89.898 107.204 97.9413 110.118 99.6787Z"
        fill="#FDD25D"
      />
      <path
        d="M110.118 99.6786L73.5 106C74.9373 103.512 82.655 96.2746 79.5 78.0001C77.2556 65.0001 64.1177 52.7698 74.8089 50.8849C85.5 49.0001 94.2776 53.3488 97.4326 71.6233C100.588 89.8979 107.204 97.9413 110.118 99.6786Z"
        fill="#F7C845"
      />
      <path
        d="M55.4918 114.184C55.022 111.462 56.8471 108.876 59.5683 108.406L110.629 99.5904C113.35 99.1206 115.937 100.946 116.407 103.667L116.683 105.266L55.7679 115.783L55.4918 114.184Z"
        fill="#F8F89C"
      />
      <path
        d="M139.452 47.2815C141.44 45.8518 144.229 46.4519 145.454 48.5732C146.678 50.6945 145.804 53.4094 143.571 54.417L133.48 58.971C132.06 59.612 130.385 59.0724 129.606 57.7229C128.827 56.3734 129.197 54.6531 130.462 53.7436L139.452 47.2815Z"
        fill="#FFA69E"
      />
      <path
        d="M118.281 36.015C119.227 33.777 121.921 32.874 124.025 34.089C126.13 35.304 126.694 38.0878 125.229 40.0267L120.681 46.0469C119.736 47.2978 118.007 47.6484 116.649 46.8646C115.291 46.0807 114.731 44.4079 115.341 42.964L118.281 36.015Z"
        fill="#FFA69E"
      />
      <path
        d="M144.055 77.0237C146.475 77.3042 148.599 75.4121 148.599 72.9755C148.599 70.5389 146.475 68.6468 144.055 68.9274L135.537 69.9146C133.983 70.0947 132.81 71.4109 132.81 72.9755C132.81 74.5401 133.983 75.8564 135.537 76.0365L144.055 77.0237Z"
        fill="#FFA69E"
      />
      <path
        d="M19.1015 100.169C16.7498 100.854 14.3208 99.3583 13.8732 96.9501C13.4257 94.5419 15.1552 92.2737 17.596 92.068L28.6279 91.1383C30.1807 91.0074 31.58 92.0744 31.8647 93.6065C32.1494 95.1385 31.2269 96.637 29.7308 97.0728L19.1015 100.169Z"
        fill="#FFA69E"
      />
      <path
        d="M35.3072 117.849C33.6686 119.643 30.8285 119.597 29.2495 117.75C27.6704 115.903 28.0661 113.09 30.0935 111.75L36.3884 107.591C37.6964 106.726 39.4435 106.972 40.4622 108.164C41.481 109.355 41.4522 111.119 40.395 112.277L35.3072 117.849Z"
        fill="#FFA69E"
      />
      <path
        d="M24.6653 70.5917C22.4769 69.5204 19.8436 70.5962 19.0313 72.8935C18.2191 75.1907 19.5909 77.6826 21.9664 78.225L30.3257 80.1335C31.8511 80.4818 33.3953 79.6316 33.9168 78.1565C34.4384 76.6814 33.7717 75.0496 32.3665 74.3617L24.6653 70.5917Z"
        fill="#FFA69E"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconBellIllustration;
